module.exports = __webpack_public_path__ + "static/img/2.d3949af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/entrance/2.png
// module id = 91Tl
// module chunks = 1